"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const js_yaml_1 = require("js-yaml");
const i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
const backend = {
    loadPath: '/assets/locale/{{lng}}.yml',
    parse: js_yaml_1.load,
};
function getDefaultLang() {
    const params = (new URL(window.location.href)).searchParams;
    return params.get('lang') || 'et';
}
i18next_1.default
    .use(i18next_http_backend_1.default)
    .use(react_i18next_1.initReactI18next)
    .init({
    lng: getDefaultLang(),
    backend,
    debug: process.env.NODE_ENV === 'development',
    keySeparator: false,
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
        wait: true,
        useSuspense: false,
    },
    fallbackLng: ['et', 'en'],
})
    .catch(console.error);
exports.default = i18next_1.default;
